// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MoveHoldingsBetweenEntitiesMutationVariables = Types.Exact<{
  input: Types.MoveHoldingsBetweenEntitiesInput;
}>;


export type MoveHoldingsBetweenEntitiesMutation = { __typename?: 'Mutation', moveHoldingsBetweenEntities: { __typename?: 'MoveHoldingsBetweenEntitiesResponse', sourceValuation?: { __typename?: 'AssetValuationV2', id: string } | null, destinationValuation?: { __typename?: 'AssetValuationV2', id: string } | null, movedPolicies: Array<{ __typename?: 'InsurancePolicy', id: string }> } };

export const Operations = {
  Mutation: {
    MoveHoldingsBetweenEntities: 'MoveHoldingsBetweenEntities' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const MoveHoldingsBetweenEntitiesDocument = gql`
    mutation MoveHoldingsBetweenEntities($input: MoveHoldingsBetweenEntitiesInput!) {
  moveHoldingsBetweenEntities(input: $input) {
    sourceValuation {
      id
    }
    destinationValuation {
      id
    }
    movedPolicies {
      id
    }
  }
}
    `;
export type MoveHoldingsBetweenEntitiesMutationFn = Apollo.MutationFunction<MoveHoldingsBetweenEntitiesMutation, MoveHoldingsBetweenEntitiesMutationVariables>;

/**
 * __useMoveHoldingsBetweenEntitiesMutation__
 *
 * To run a mutation, you first call `useMoveHoldingsBetweenEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveHoldingsBetweenEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveHoldingsBetweenEntitiesMutation, { data, loading, error }] = useMoveHoldingsBetweenEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveHoldingsBetweenEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<MoveHoldingsBetweenEntitiesMutation, MoveHoldingsBetweenEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveHoldingsBetweenEntitiesMutation, MoveHoldingsBetweenEntitiesMutationVariables>(MoveHoldingsBetweenEntitiesDocument, options);
      }
export type MoveHoldingsBetweenEntitiesMutationHookResult = ReturnType<typeof useMoveHoldingsBetweenEntitiesMutation>;
export type MoveHoldingsBetweenEntitiesMutationResult = Apollo.MutationResult<MoveHoldingsBetweenEntitiesMutation>;
export type MoveHoldingsBetweenEntitiesMutationOptions = Apollo.BaseMutationOptions<MoveHoldingsBetweenEntitiesMutation, MoveHoldingsBetweenEntitiesMutationVariables>;